import {
    Building2,
    Headphones,
    IndianRupee,
    MessageCircle,
    MonitorPlay,
    Plug,
    Rocket,
    ShieldCheck,
    Sparkles,
    Users2,
} from "lucide-react";

export const CONTACT_SALES_TOPICS = [
    {
        id: "new-eval",
        icon: Sparkles,
        title: "ApexBrain Walkthrough",
        body: "Module walkthrough, ROI estimate, and a security overview tailored to your business.",
        accent: "text-electric",
        chip: "bg-electric/10 border-electric/25",
    },
    {
        id: "demo",
        icon: MonitorPlay,
        title: "Request a product demo",
        body: "Live demo across sales, HR, projects, and finance — see workflows your team actually runs.",
        accent: "text-cyan-300",
        chip: "bg-cyan-300/10 border-cyan-300/25",
    },
    {
        id: "pricing",
        icon: IndianRupee,
        title: "Pricing & licensing inquiry",
        body: "Plan comparison, license bands, annual billing, and procurement-ready quotes.",
        accent: "text-emerald-300",
        chip: "bg-emerald-300/10 border-emerald-300/25",
    },
    {
        id: "migration",
        icon: Building2,
        title: "Migrating from another platform",
        body: "Move from Jira, Monday, ClickUp, or a SaaS stack with a dedicated migration engineer.",
        accent: "text-teal-300",
        chip: "bg-teal-300/10 border-teal-300/25",
    },
    {
        id: "integration",
        icon: Plug,
        title: "Technical integration & API",
        body: "Webhooks, SSO, data sync, and custom integrations with your existing tools.",
        accent: "text-sky-300",
        chip: "bg-sky-300/10 border-sky-300/25",
    },
    {
        id: "enterprise",
        icon: ShieldCheck,
        title: "Enterprise & compliance requirements",
        body: "SOC 2, ISO 27001, custom contracts, dedicated tenancy, and regulated-industry needs.",
        accent: "text-amber-glow",
        chip: "bg-amber-300/10 border-amber-300/25",
    },
    {
        id: "onboarding",
        icon: Rocket,
        title: "Implementation & onboarding support",
        body: "Rollout planning, admin setup, team training, and a go-live timeline that sticks.",
        accent: "text-orange-300",
        chip: "bg-orange-300/10 border-orange-300/25",
    },
    {
        id: "partner",
        icon: Users2,
        title: "Partnership or reseller program",
        body: "Integration partners, regional resellers, and white-label conversations.",
        accent: "text-violet-300",
        chip: "bg-violet-300/10 border-violet-300/25",
    },
    {
        id: "existing-customer",
        icon: Headphones,
        title: "Existing customer — account inquiry",
        body: "Billing, seat changes, upgrades, renewals, or support for your active workspace.",
        accent: "text-pink-300",
        chip: "bg-pink-300/10 border-pink-300/25",
    },
    {
        id: "general",
        icon: MessageCircle,
        title: "General business inquiry",
        body: "Anything else — tell us what you’re trying to solve and we’ll route you to the right person.",
        accent: "text-zinc-300",
        chip: "bg-white/5 border-white/15",
    },
];

export const CONTACT_REASONS = [
    { id: "new-eval", label: "ApexBrain Walkthrough" },
    { id: "demo", label: "Request a product demo" },
    { id: "pricing", label: "Pricing & licensing inquiry" },
    { id: "migration", label: "Migrating from another platform" },
    { id: "integration", label: "Technical integration & API" },
    { id: "enterprise", label: "Enterprise & compliance requirements" },
    { id: "onboarding", label: "Implementation & onboarding support" },
    { id: "partner", label: "Partnership or reseller program" },
    { id: "existing-customer", label: "Existing customer — account inquiry" },
    { id: "general", label: "General business inquiry" },
];

export const DEFAULT_CONTACT_SALES_FORM = {
    name: "",
    email: "",
    company: "",
    website_url: "",
    reason: "new-eval",
    seats: "20–50",
    timeline: "Within 30 days",
    message: "",
};

export const CONTACT_SEAT_OPTIONS = [
    "1–8 (free)",
    "9–19",
    "20–50",
    "51–200",
    "200+",
];

export const CONTACT_TIMELINE_OPTIONS = [
    "This week",
    "Within 30 days",
    "This quarter",
    "Exploring",
];
